import { NavigateOptions } from "react-router";
import { ScanResultType } from "../types/ScanResultType";
import { extractBasedOnSymbology } from "./extractBasedOnSymbologyUtils";

export const handleScanResult = (
  barcode: ScanResultType,
  location: string,
  navigate: (to: string, options?: NavigateOptions) => void
) => {
  const articleInformation = extractBasedOnSymbology(
    barcode.symbologyFormat,
    barcode.scannedBarcode
  );

  if (location === "global")
    navigate(`/product/ART${articleInformation.articleNumber}`);
  else {
    navigate(`/task/new/${location}`, {
      state: {
        product: {
          supplierNumber: articleInformation.supplierNumber,
          product: articleInformation.articleNumber,
          type: "ART",
        },
      },
    });
  }
};
